<template>
  <div>
    <section class="mt-[2rem]">
      <div class="max-w-7xl mx-auto p-4 lg:p-0">
        <div class="flex flex-col gap-2">
          <h2
            class="text-black font-bold text-[24px] md:text-center text-left md:text-[35px]"
          >
            Career Advancement Services
          </h2>
          <div class="flex gap-2 md:flex-row md:justify-center">
            <h2 class="md:text-[21px] text-[16px] text-black">Powered by</h2>
            <img
              src="@/assets/electiveDetail/founditLogo-primary.png"
              alt=""
              class="w-[90px]"
            />
          </div>
          <p class="text-[16px] text-left md:text-center">
            JAIN Online, in collaboration with foundit, powers a range of career
            services for its learners <br class="hidden md:block" />
            to enhance their job search and career prospects.
          </p>
        </div>
        <div class="py-5">
          <div class="slick_career flex flex-wrap gap-3 justify-between">
            <div
              class="lg:w-[290px] md:w-[370px] px-4 lg:px-0"
              v-for="career in careers"
              :key="career.id"
            >
              <div class="bg-white shadow-lg rounded-xl border h-full">
                <div>
                  <img :src="career.image" alt="" class="w-full h-[250px]" />
                </div>
                <div class="p-4 min-h-[165px]">
                  <h2
                    class="text-black font-bold text-[14px] lg:text-lg text-left"
                  >
                    {{ career.title }}
                  </h2>
                  <p class="text-black text-[14px] text-left">
                    {{ career.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  name: "CareerView",
  data() {
    return {
      careers: [
        {
          id: 1,
          image: require("@/assets/electiveDetail/career&addsup/Career-services-1desktop.webp"),
          title: " Professional Resumes",
          description:
            " Our expert team, backed by foundit, crafts high-quality,industry-specific resumes to significantly improve learners’ chances of securing their desired jobs.",
        },
        {
          id: 2,
          image: require("@/assets/electiveDetail/career&addsup/Career-services-2desktop.webp"),
          title: "Interview Preparation Guide",
          description:
            " Learners receive a comprehensive guide powered by foundit to boost essential skills, knowledge, and confidence for successful job interviews.",
        },
        {
          id: 3,
          image: require("@/assets/electiveDetail/career&addsup/Career-services-3desktop.webp"),
          title: "Featured Profile",
          description:
            " Elevate your profile on foundit with priority attention, relevant job alerts, and 3x higher shortlisting chances, connecting you with at least 5 domain-specific recruiters.",
        },
        {
          id: 4,
          image: require("@/assets/electiveDetail/career&addsup/Career-services-4desktop.webp"),
          title: " Profile Highlighter",
          description:
            " Access the powerful foundit Profile Highlighter tool, ensuring instant attention from recruiters and giving you a competitive advantage as an active job seeker.",
        },
      ],
    };
  },
  mounted() {
    $(`.slick_career`).slick({
      infinite: true,
      autoplay: true,
      prevArrow: false,
      nextArrow: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      dotsClass: "slick-dots",

      responsive: [
        {
          breakpoint: 1040,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};
</script>

<style>

</style>
